import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    NOTIFICATIONS_FEATURE_KEY,
    State,
    notificationsAdapter,
} from './notifications.reducer';

// Lookup the 'Notifications' feature state managed by NgRx
export const getNotificationsState = createFeatureSelector<State>(
    NOTIFICATIONS_FEATURE_KEY
);

const { selectAll, selectEntities } = notificationsAdapter.getSelectors();

export const getNotificationsLoaded = createSelector(
    getNotificationsState,
    (state: State) => state.loaded
);

export const getNotificationsError = createSelector(
    getNotificationsState,
    (state: State) => state.error
);

export const getAllNotifications = createSelector(
    getNotificationsState,
    (state: State) => selectAll(state)
);

export const getNotificationsEntities = createSelector(
    getNotificationsState,
    (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
    getNotificationsState,
    (state: State) => state.selectedId
);

export const getSelected = createSelector(
    getNotificationsEntities,
    getSelectedId,
    (entities, selectedId) => (selectedId ? entities[selectedId] : undefined)
);

export const getPaginationInfo = createSelector(
    getNotificationsState,
    (state: State) => ({
        total: state.total,
        current: Math.min(
            (state.perPage ?? 0) * (state.loadedPage ?? 0),
            state.total ?? 0
        ),
    })
);

export const canLoadPage = createSelector(
    getNotificationsState,
    (state: State) => (state.loadedPage ?? 0) < (state.lastPage ?? 0)
);

export const getLoadedPage = createSelector(
    getNotificationsState,
    (state: State) => state.loadedPage
);

export const getUnreadCount = createSelector(
    getNotificationsState,
    (state: State) => state.unread
);

export const getIsLoadingPage = createSelector(
    getNotificationsState,
    (state: State) => state.loadingPage
);
